const is_svg_f_m =
  (typeof window !== 'undefined' ? window : {}).URLSearchParams &&
  new URLSearchParams(location.search).get('is_svg_f_m') === 'true';
export const isForceM = () => {
  return is_svg_f_m;
};
